import Layout from "@/components/layout/Layout.vue"
import CreateForm from "@/views/sys/privilege/create/Create.vue"
import { getPrivileges, deletePrivileges } from "@/api/privilege"

const columns = [
    { title: '名称', dataIndex: 'name' },
    { title: '权限标识', dataIndex: 'route', ellipsis: true, scopedSlots: { customRender: 'route-name' } },
    { title: '前端路径', dataIndex: 'url', ellipsis: true, scopedSlots: { customRender: 'url' } },
    { title: '操作', dataIndex: '', scopedSlots: { customRender: 'action' } }
]

export default {
    name: 'privileges',
    components: {
        Layout,
        CreateForm
    },
    data () {
        return {
            data: [],
            pagination: { defaultPageSize: 20 },
            loading: false,
            selectedRowKeys: [],
            columns,
            model: {},
            showForm: false,
            queryParam: {}
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        create(record, parent_id = null) {
            this.model = record && record.id ? Object.assign({}, record) : { hidden: false, parent_id:parent_id }
            this.showForm = true
        },
        destroy(record) {
            const del = ids => {
                deletePrivileges(ids).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            del([record.id])
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = {
                page: pagination.current,
                page_size: pagination.defaultPageSize
            }
            getPrivileges(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('PrivilegeController', route)
        },
    }
}
